module.exports = __webpack_public_path__ + "static/scale-model-of-studio-801-in-virginia-beach-virginia-84139768500a75eb7a50e6d0fb2e1670.png";